import React, { Component } from "react";
import config from "../../../config";

const regionMap = {
  au: 7,
  nz: 8,
};
export default class SignUpCommercial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: this.props.email || "",
      name: "",
      password1: "",
      password2: "",
      showPassword: false,
      storeLocationId: [{ value: "", label: "" }],
      storeLocation: [],
      typePassword: true,
      errorPassword: false,
      errorStoreLocation: false,
      commercial_location_notes: "",
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    let payload = {
      brand_id: config.backendServer.includes("develop")
        ? Object.entries(regionMap).find(([key]) =>
            config.baseUrl.includes(key)
          )?.[1] || ""
        : config.countryBrandId,
      name: this.state.name,
      email: this.state.email,
      password: this.state.password1,
      commercial_location_notes: this.state.commercial_location_notes,
      // location_id: this.state.storeLocationId || "",
    };

    if (this.state.password1 !== this.state.password2) {
      this.setState({
        loading: false,
        errorPassword: true,
        errorBrand: false,
        errorStoreLocation: false,
      });
    } else if (
      !payload.commercial_location_notes &&
      payload.commercial_location_notes === ""
    ) {
      this.setState({
        loading: false,
        errorPassword: false,
        errorStoreLocation: true,
        errorBrand: false,
      });
    } else {
      this.props.onSubmit({ ...payload });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  componentDidMount() {
    this.getDataStoreLocation();
  }

  getDataStoreLocation = () => {
    let url = config.backendServer + "store_locations/" + `?country=${config.country}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          const error = await response.json();
          throw error;
        }
      })
      .then((response) => {
        const res = JSON.parse(response);
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });
        this.setState({ storeLocation: options });
      })
      .catch((resp) => {
        const regex = new RegExp(`[${["{", "}", '"'].join("")}]`, "g");
        const errorDetail =
          resp.non_field_errors || JSON.stringify(resp).replace(regex, "");
        this.setState({
          invalidLoginTriggered: errorDetail,
          successConvertTriggered: null,
        });
      });
  };

  render() {
    return (
      <div className="card">
        <h4 className={"card-header"}>Registration</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Full name<span>:</span>
              </label>
              <input
                type="text"
                id="name"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Email <span>:</span>
              </label>
              <input
                type="email"
                id="email"
                defaultValue={this.state.email}
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Password{" "}
                <i
                  className={
                    this.state.typePassword
                      ? "password-show fa fa-eye"
                      : "password-show fa fa-eye-slash"
                  }
                  aria-hidden="true"
                  onClick={() =>
                    this.setState({
                      typePassword: !this.state.typePassword,
                    })
                  }
                ></i>
                <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password1"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Confirm Password <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password2"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Store Location<span>:</span>
              </label>
              <input
                id="commercial_location_notes"
                required={true}
                placeholder="Store name - Store Location"
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorStoreLocation ? (
                <span className="error-text">Store location required</span>
              ) : null}
            </div>
          </div>

          <div className="card-footer">
            <div className="d-flex flex-row mb-3 gap-2">
              <div>
                <button type="submit" className={"btn btn-outline-primary"}>
                  Register
                </button>
              </div>
              <div>
                <button
                  className={"btn btn-outline-secondary"}
                  onClick={this.props.onCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
